module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8RtA8"))).then(() => parcelRequire('d0iPb'));